import { Userpilot } from 'userpilot';
import TrackingAbstract from './_trackingAbstract';
import { getName } from '../../common/utils/users';
import config from '../env.config';
import { capitalize, isNumber, isString } from 'lodash';
import { determinePlan } from '../../common/institution/plan';
const USERPILOT_EVENTS = ['started', 'completed', 'dismissed', 'step'];
export function isValidInstitution(institution, plan) {
    return (isNumber(institution.id) &&
        isString(institution.name) &&
        plan.type !== 'free');
}
export default class UserpilotTracking extends TrackingAbstract {
    initProvider(_authenticated) {
        Userpilot.initialize(config.userpilotJsToken, {
            domain: 'userpilot-js.doxy.me',
        });
        for (const event of USERPILOT_EVENTS) {
            Userpilot.on(event, (data) => {
                // Yes, we are logging Userpilot events to Segment, here in the Userpilot tracking class.
                this.$window.analytics.track(`Userpilot - ${event}`, data);
            });
        }
    }
    identifyUser(user, institution, meta) {
        const purchase = meta.purchases[0] ?? {};
        const plan = determinePlan(purchase.planId, purchase.seats);
        // This isn't optimal as users can be part of many institutions, but
        // UserPilot doesn't allow for the concept of a user part of many companies
        const membership = user.institutionMember;
        // Note, the user object has the institution object available if the
        // user is a member of an institution. Often, the "institution" argument,
        // second arg, is not materialized by the point the identifyUser function
        // is called
        const resolvedInstitution = membership?.institution ?? institution;
        const seats = purchase.institutionId === resolvedInstitution.id ? purchase.seats : null;
        const userObject = {
            user_id: user.id,
            user_hash: user.hash,
            user_type: 'user',
            name: getName(user),
            email: user.email,
            created_at: user.created,
            trialEnd_at: user.trialEndDate,
            betaAccess: user.betaAccesses,
            plan: plan.planId,
            plan_type: capitalize(plan.type),
            plan_currency: plan.currency,
            plan_version: plan.version,
            plan_period: plan.interval,
            roomSlug: meta.roomSlug,
            specialty: user.speciality,
            institution_id: resolvedInstitution.id,
            company: isValidInstitution(resolvedInstitution, plan)
                ? {
                    id: resolvedInstitution.id,
                    name: resolvedInstitution.name,
                    plan: plan.planId,
                    created_at: resolvedInstitution.created,
                    role: membership.role,
                    seats,
                }
                : null,
        };
        Userpilot.identify(user.id.toString(), userObject);
    }
    unidentifyUser() {
        // Userpilot does not have an unidentify method.
    }
    track(eventName, properties, _context) {
        Userpilot.track(eventName, properties);
    }
    trackWithoutParams(eventName, _context) {
        Userpilot.track(eventName);
    }
    trackWithExplicitProperties(eventName, properties) {
        Userpilot.track(eventName, properties);
    }
    trackPageView() {
        Userpilot.reload();
    }
    trackScreenshare(phase, data = {}) {
        Userpilot.track(`Screenshare ${phase}`, data);
    }
}
